import React from 'react';


const SimpleOverlay = ({ children, toggleOverlay }) => <div className="SimpleOverlay" onClick={toggleOverlay}>{children}</div>

export default SimpleOverlay



// WEBPACK FOOTER //
// ./src/components/SimpleOverlay.js